import { Bookmark, BrainCircuit, ClipboardCheck, Database, Home, Megaphone, MessageCircleQuestion, Palette, Rocket, Search, Settings, ShieldCheck, Sparkles, Stethoscope } from "lucide-react";
import { NavLink } from "react-router-dom";
import { cn } from "../../lib/cn";
import { isAdminRole, useAuthStore } from "../../features/auth/authStore";

const navItems = [
  { to: "/home", label: "ホーム", icon: Home },
  { to: "/questions", label: "質問", icon: MessageCircleQuestion },
  { to: "/deep-dive", label: "深掘り", icon: BrainCircuit },
  { to: "/swipe", label: "スワイプ", icon: Sparkles },
  { to: "/diagnosis", label: "診断", icon: Stethoscope },
  { to: "/design", label: "デザイン", icon: Palette },
  { to: "/marketing", label: "マーケ", icon: Megaphone },
  { to: "/pre-launch", label: "ローンチ前", icon: ClipboardCheck },
  { to: "/vibe-deploy", label: "デプロイ", icon: Rocket },
  { to: "/saved", label: "保存", icon: Bookmark },
  { to: "/settings", label: "設定", icon: Settings }
];

const adminNavItems = [
  { to: "/admin/samples", label: "サンプル投入", icon: Database },
  { to: "/admin/settings", label: "プロフィール設定", icon: Settings },
  { to: "/admin/research", label: "調査", icon: Search },
  { to: "/admin/cost", label: "コスト追跡", icon: ShieldCheck }
];

export function Sidebar({ mobile = false, onNavigate }: { mobile?: boolean; onNavigate?: () => void }) {
  const role = useAuthStore((state) => state.role);
  const visibleNavItems = isAdminRole(role) ? adminNavItems : navItems;

  return (
    <aside
      className={cn(
        "flex h-full flex-col border-[color:var(--border)] bg-[color:var(--surface)]",
        mobile ? "w-72 border-r pt-16" : "hidden w-72 shrink-0 border-r lg:flex"
      )}
    >
      <nav className="flex flex-col gap-1 px-3 py-4">
        {visibleNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) =>
                cn(
                  "flex min-h-11 items-center gap-3 rounded-card px-3 text-sm font-semibold transition",
                  isActive
                    ? "bg-[color:var(--surface-raised)] text-[color:var(--text)]"
                    : "text-[color:var(--muted)] hover:bg-[color:var(--surface-raised)] hover:text-[color:var(--text)]"
                )
              }
            >
              <Icon className="h-4 w-4" aria-hidden />
              {item.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="mt-auto p-4">
        <div className="rounded-card border border-[color:var(--border)] bg-[color:var(--surface-raised)] p-4">
          <p className="text-sm font-semibold text-[color:var(--text)]">AIモデル切替対応</p>
          <p className="mt-2 text-xs leading-5 text-[color:var(--muted)]">SettingsでWorkers AIのallowlistから選択できます。</p>
        </div>
      </div>
    </aside>
  );
}
